<template>
  <app-view>
    <div class="list">
      <router-link v-for="(item,index) in priest" :key="index"
                   :to="{name:'bookshelf',params:{catid:item.id},query:{name:item.category}}">
        <img :src="item.thumb">
        <div>{{item.category}}</div>
      </router-link>
    </div>
  </app-view>
</template>
<script>
  import AppView from '../components/AppView.vue'

  export default {
    components: {AppView},
    computed: {
      priest () {
        return this.$service.category.priest
      }
    },
    mounted () {
      this.$service.category.loadPriests()
    }
  }
</script>
<style scoped lang='scss'>
  .list {
    display: flex;
    flex-wrap: wrap;
    padding: rem(5);
    > a {
      display: inline-block;
      width: rem(175);
      font-size: rem(28);
      margin: rem(5);
      text-align: center;
      background-color: $color-white;
      overflow: hidden;
      img {
        width: 100%;
      }
      > div {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &:active {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }

  @media screen and (min-width: 768px) {
    .view {
      a {
        width: rem(117);
        margin: rem(3);
        font-size: rem(16);
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .view {
      a {
        width: rem(88);
        margin: rem(2.2);
        font-size: rem(12);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// priest.vue?372e6316